/**
 * NavaLogo — logo institucional da NAVA, exibido JUNTO da marca Sphere (não a substitui):
 * abaixo dela no menu lateral e nas telas de abertura, login e MFA, centralizado.
 *
 * Arquivos de `Logo NAVA Sphere_transp/`, recortados no conteúdo (o original tem margem de
 * tela cheia): `12.svg` (letras escuras) para fundo claro e `11.svg` (o mesmo logo, letras
 * claras) para fundo escuro. A escolha é pela luminância do fundo do tema — com letras
 * escuras num tema escuro o nome "Nava" some.
 *
 * `largura` em px; a altura segue a proporção do logo (2687 × 606).
 */
import { C } from '@/theme/palette';
import logoFundoClaro from '@/assets/nava/nava-logo-fundo-claro.svg';
import logoFundoEscuro from '@/assets/nava/nava-logo-fundo-escuro.svg';

const PROPORCAO = 606 / 2687;

/** Luminância relativa (0 = preto, 1 = branco) de uma cor `#rgb`/`#rrggbb`. */
export function luminancia(hex) {
  const m = /^#?([0-9a-f]{6}|[0-9a-f]{3})$/i.exec(String(hex ?? '').trim());
  if (!m) return 0;
  const h = m[1].length === 3 ? [...m[1]].map((c) => c + c).join('') : m[1];
  const [r, g, b] = [0, 2, 4].map((i) => {
    const v = parseInt(h.slice(i, i + 2), 16) / 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

/** `true` quando o fundo pede o logo de letras escuras (12.svg). */
export function fundoClaro(corDeFundo) {
  return luminancia(corDeFundo) > 0.4;
}

export function NavaLogo({ largura = 96, fundo = C.black, className, style }) {
  const claro = fundoClaro(fundo);
  return (
    <img
      src={claro ? logoFundoClaro : logoFundoEscuro}
      alt="NAVA"
      width={largura}
      height={Math.round(largura * PROPORCAO)}
      className={className}
      data-variante={claro ? 'fundo-claro' : 'fundo-escuro'}
      draggable={false}
      style={{ display: 'block', maxWidth: '100%', height: 'auto', ...style }}
    />
  );
}
